// An account's saved commission and fee rates (Account.feeRule): { per: 'side' | 'round',
// rates: [{ symbol: 'ALL' | 'MNQ' | …, commission, fees }] }. The server fills in fees with
// the same math (tradeMath.js feeFor); keep the two in step.
import { rootSymbol } from './tools/contracts';

export function rateFor(rule, symbol) {
  if (!rule || !Array.isArray(rule.rates)) return null;
  const root = rootSymbol(symbol);
  return rule.rates.find((r) => r.symbol === root) || rule.rates.find((r) => r.symbol === 'ALL') || null;
}

// Commission + fees for one contract in and out, in dollars.
export function roundTripPerContract(rule, rate) {
  return ((rate.commission || 0) + (rate.fees || 0)) * (rule.per === 'side' ? 2 : 1);
}

// Fees for one trade, or null when the rates don't cover it.
export function feeFor(rule, trade) {
  const rate = rateFor(rule, trade.symbol);
  if (!rate) return null;
  const perContract = roundTripPerContract(rule, rate);
  if (!(perContract > 0)) return null;
  return Math.round(perContract * (Number(trade.size) || 1) * 100) / 100;
}

// The trades saving `rule` would change: no fees yet, or fees filled in from earlier rates.
export function tradesToUpdate(rule, trades) {
  return trades.filter((t) => {
    if (t.fees > 0 && !t.feesAuto) return false;
    const fee = feeFor(rule, t);
    return fee !== null && Math.abs(fee - (t.fees || 0)) > 0.004;
  });
}
